export var BankDetailsFormatterFactory = (function() {
    /* Public Functions */

    var getFormatter = function(countryCode) {
        if ((countryCode.toLowerCase() + 'Formatter') in formatterCollection) {
            return new formatterCollection[countryCode.toLowerCase() + 'Formatter']();
        } else {
            return new formatterCollection.baseFormatter();
        }
    };

    /* Private Variables */

    // market-specific formatters
    var formatterCollection = {};

    /* Private Functions */

    // helper for setting up inheritance
    var inheritsFrom = function(child, parent) {
        child.prototype = Object.create(parent.prototype);
    };

    /* Formatters */

    // base formatter stubs each property setter
    var BaseFormatter = function() {};
    BaseFormatter.prototype.setAcceptedDirectDepositPolicy = function() {};
    BaseFormatter.prototype.setAccountHolder = function() {};
    BaseFormatter.prototype.setAccountNumber = function() {};
    BaseFormatter.prototype.setAccountType = function() {};
    BaseFormatter.prototype.setAction = function() {};
    BaseFormatter.prototype.setBank = function() {};
    BaseFormatter.prototype.setControlKey = function() {};
    BaseFormatter.prototype.setCountryCode = function() {};
    BaseFormatter.prototype.setDistributor = function() {};
    BaseFormatter.prototype.setIBAN = function() {};
    BaseFormatter.prototype.setRoutingNumber = function() {};
    BaseFormatter.prototype.setSystemId = function() {};
    BaseFormatter.prototype.setUserId = function() {};
    formatterCollection.baseFormatter = BaseFormatter;


    var PfFormatter = function() {};
    inheritsFrom(PfFormatter, BaseFormatter);
    PfFormatter.prototype.setAccountNumber = function(payload, data) {
        if (data.IBAN) {
            payload.accountNumber = data.IBAN.substr(14, data.ibanRequiredLength - 1);
        }
    };
    PfFormatter.prototype.setRoutingNumber = function(payload, data) {
        if (data.IBAN) {
            payload.routingNumber = data.IBAN.substr(7, 5);
        }
    };
    formatterCollection.pfFormatter = PfFormatter;


    // EMEA formatter overrides a subset of the property setters with behavior common across EMEA markets
    var EmeaFormatter = function() {};
    inheritsFrom(EmeaFormatter, BaseFormatter);
    EmeaFormatter.prototype.setAcceptedDirectDepositPolicy = function(payload) {
        payload.acceptedDirectDepositPolicy = true;
    };
    EmeaFormatter.prototype.setAccountHolder = function(payload, data) {
        payload.accountHolder = data.accountHolder;
    };
    EmeaFormatter.prototype.setAccountNumber = function(payload, data) {
        if (data.IBAN) {
            payload.accountNumber = data.IBAN.substr(14, 11);
        }
    };
    EmeaFormatter.prototype.setAction = function(payload) {
        payload.action = 'ADD';
    };
    EmeaFormatter.prototype.setCountryCode = function(payload, countryCode) {
        payload.countryCode = countryCode;
    };
    EmeaFormatter.prototype.setIBAN = function(payload, data) {
        if (data.IBAN) {
            payload.IBAN = data.IBAN;
        }
    };


    // Spain formatter inherits from EMEA formatter
    var EsFormatter = function() {};
    inheritsFrom(EsFormatter, EmeaFormatter);
    EsFormatter.prototype.setAccountNumber = function(payload, data) {
        if (data.IBAN) {
            payload.accountNumber = data.IBAN.substr(14);
        }
    };
    EsFormatter.prototype.setRoutingNumber = function(payload, data) {
        if (data.IBAN) {
            payload.routingNumber = data.IBAN.substr(4, 8);
        }
    };
    EsFormatter.prototype.setControlKey = function(payload, data) {
        if (data.IBAN) {
            payload.controlKey = data.IBAN.substr(12, 2);
        }
    };
    formatterCollection.esFormatter = EsFormatter;


    // France formatter inherits from EMEA formatter
    var FrFormatter = function() {};
    inheritsFrom(FrFormatter, EmeaFormatter);
    FrFormatter.prototype.setRoutingNumber = function(payload, data) {
        if (data.IBAN) {
            // Routing number consists of the bank identifier and branch identifier
            payload.routingNumber = data.IBAN.substr(4, 10);
        }
    };
    FrFormatter.prototype.setControlKey = function(payload, data) {
        if (data.IBAN) {
            // SAP requires a control key for FR which is the last two digits of the IBAN
            payload.controlKey = data.IBAN.substr(25, 2);
        }
    };
    formatterCollection.frFormatter = FrFormatter;


    // United Kingdom formatter inherits from EMEA formatter
    var GbFormatter = function() {};
    inheritsFrom(GbFormatter, EmeaFormatter);
    GbFormatter.prototype.setRoutingNumber = function(payload, data) {
        if (data.IBAN) {
            payload.routingNumber = data.IBAN.substr(8, 6);
        }
    };
    formatterCollection.gbFormatter = GbFormatter;


    // non EMEA formatter overrides a subset of the property setters with behavior common across non-EMEA markets
    var NonEmeaFormatter = function() {};
    inheritsFrom(NonEmeaFormatter, BaseFormatter);
    NonEmeaFormatter.prototype.setAccountHolder = function(payload, data) {
        payload.registeredName = data.accountHolder;
    };
    NonEmeaFormatter.prototype.setAccountNumber = function(payload, data) {
        payload.accountNumber = data.accountNumber;
    };
    NonEmeaFormatter.prototype.setAccountType = function(payload) {
        payload.accountType = 'N';
    };
    NonEmeaFormatter.prototype.setDistributor = function(payload, countryCode, accountId) {
        payload.distributor = {
            countryCode: countryCode,
            distributorId: accountId
        };
    };
    NonEmeaFormatter.prototype.setSystemId = function(payload) {
        payload.systemId = 'CPM';
    };
    NonEmeaFormatter.prototype.setUserId = function(payload, accountId) {
        payload.userId = accountId;
    };


    // Australia formatter inherits from non EMEA formatter
    var AuFormatter = function() {};
    inheritsFrom(AuFormatter, NonEmeaFormatter);
    AuFormatter.prototype.setBank = function(payload, data) {
        if (data.branchNumber) {
            payload.bank = {
                number: data.branchNumber.slice(0, 3) + '-' + data.branchNumber.slice(3, 6)
            };
        }
    };
    formatterCollection.auFormatter = AuFormatter;


    // Canada formatter inherits from non EMEA formatter
    var CaFormatter = function() {};
    inheritsFrom(CaFormatter, NonEmeaFormatter);
    CaFormatter.prototype.setBank = function(payload, data) {
        payload.bank = {
            branches: [{
                // The branch name is represented by the numeric value
                name: data.routingNumber
            }],
            number: data.bankNumber
        };
    };
    formatterCollection.caFormatter = CaFormatter;


    // New Zealand formatter inherits from non EMEA formatter
    var NzFormatter = function() {};
    inheritsFrom(NzFormatter, NonEmeaFormatter);
    NzFormatter.prototype.setBank = function(payload, data) {
        payload.bank = {
            branches: [{
                name: data.branchNumber
            }],
            number: data.bankNumber
        };
    };
    formatterCollection.nzFormatter = NzFormatter;


    // United States formatter inherits from non EMEA formatter
    var UsFormatter = function() {};
    inheritsFrom(UsFormatter, NonEmeaFormatter);
    UsFormatter.prototype.setAccountType = function(payload, data) {
        if (data.accountType && data.accountType.toLowerCase() === 'savings') {
            payload.accountType = 'S';
        } else if (data.accountType && data.accountType.toLowerCase() === 'checking') {
            payload.accountType = 'C';
        }
    };
    UsFormatter.prototype.setBank = function(payload, data) {
        payload.bank = {
            number: data.routingNumber
        };
    };
    formatterCollection.usFormatter = UsFormatter;


    /* Expose Public Functions */

    return {
        getFormatter: getFormatter
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/banking/bank-details-formatter.js
// module id = 176
// module chunks = 0